// src/composables/useGlobal.ts
import { ref } from "vue";
import dayjs from "dayjs";
import router from "@/router/index";

import Swal from "sweetalert2";
import i18n from "@/i18n/index";

import type { ManipulateType } from "dayjs";
export function useGlobal() {
  const formaDate = (DateString: any): string => {
    if (DateString) return dayjs(DateString).format("DD/MM/YYYY");
    else return "";
  };

  const calculateAge = (DateString: any): string => {
    return dayjs().diff(dayjs(DateString), "year") + " ans";
  };

  const formaTime = (TimeString: any): string => {
    if (TimeString) {
      // Split the time string into hours, minutes, and seconds
      const parts = TimeString.split(":");

      if (parts.length === 3) {
        const hours = parts[0];
        const minutes = parts[1];

        // Return formatted time as "HH:mm"
        return `${hours}:${minutes}`;
      }
    }
    return ""; // Return empty if no valid time is provided
  };

  const DatesSubtract = (
    subtract: number,
    type: ManipulateType
  ): [string, string] => {
    const currentDate = ref(dayjs().format("YYYY-MM-DD")); // Format as needed
    const subtractDate = ref(
      dayjs().subtract(subtract, type).format("YYYY-MM-DD")
    ); // Format as needed
    return [subtractDate.value, currentDate.value];
  };
  const DatesAdds = (add: number, type: ManipulateType): [string, string] => {
    //const currentDate = ref(dayjs().format('YYYY-MM-DD')); // Format as needed
    const start_date = ref(dayjs().subtract(add, type).format("YYYY-MM-DD")); // Format as needed
    const end_date = ref(dayjs().add(add, type).format("YYYY-MM-DD")); // Format as needed
    return [start_date.value, end_date.value];
  };

  const dateAdd = (add: number, type: ManipulateType): string => {
    const currentDate = ref(dayjs()); // Format as needed

    if (add) {
      return currentDate.value.add(add, type).format("YYYY-MM-DD");
    } else return currentDate.value.format("YYYY-MM-DD");
  };

  const redirectTo = (obj: object) => {
    router.push(obj);
  };

  const goBack = () => {
    router.go(-1);
  };
  const playSound = (fileName) => {
    const audio = new Audio(`/sound/${fileName}`);
    audio.play();
  };

  const getColorByIndex = (index) => {
    const colors = [
      "#3498db", // Bright Blue
      "#e74c3c", // Red (for a strong contrast)
      "#2ecc71", // Green (vibrant)
      "#f39c12", // Yellow (warm and attention-grabbing)
      "#9b59b6", // Purple (rich and elegant)
      "#FF5733", // Fiery Red-Orange
      "#33FF57", // Neon Green
      "#3357FF", // Vivid Blue
      "#FF33A1", // Hot Pink
      "#9C27B0", // Deep Purple
      "#FFC107", // Amber Yellow
      "#1abc9c", // Teal (calm and balanced)
    ];

    return colors[index];
  };

  const getListMonths = () => {
    const months = ref<string[]>([
      i18n.t("date.month.january"),
      i18n.t("date.month.february"),
      i18n.t("date.month.march"),
      i18n.t("date.month.april"),
      i18n.t("date.month.may"),
      i18n.t("date.month.june"),
      i18n.t("date.month.july"),
      i18n.t("date.month.august"),
      i18n.t("date.month.september"),
      i18n.t("date.month.october"),
      i18n.t("date.month.november"),
      i18n.t("date.month.december"),
    ]);
    return months;
  };

  const priceToWords = (number: number) => {
    const units = [
      "",
      "un",
      "deux",
      "trois",
      "quatre",
      "cinq",
      "six",
      "sept",
      "huit",
      "neuf",
    ];
    const tens = [
      "",
      "dix",
      "vingt",
      "trente",
      "quarante",
      "cinquante",
      "soixante",
      "",
      "quatre-vingt",
      "",
    ];

    const belowTwenty = [
      "dix",
      "onze",
      "douze",
      "treize",
      "quatorze",
      "quinze",
      "seize",
      "dix-sept",
      "dix-huit",
      "dix-neuf",
    ];

    function convertBelowHundred(n: number): string {
      if (n < 10) return units[n];
      if (n < 20) return belowTwenty[n - 10];
      if (n < 70) {
        const ten = Math.floor(n / 10);
        return tens[ten] + (n % 10 > 0 ? "-" + units[n % 10] : "");
      }
      if (n < 80) {
        return "soixante-" + belowTwenty[n - 70];
      }
      return (
        "quatre-vingt" +
        (n % 20 > 0
          ? n % 20 < 10
            ? "-" + units[n % 20]
            : "-" + belowTwenty[(n % 20) - 10]
          : "")
      );
    }

    function convertBelowThousand(n: number): string {
      let words = "";

      if (n >= 100) {
        const hundreds = Math.floor(n / 100);
        words += hundreds === 1 ? "cent" : units[hundreds] + " cent";
        if (n % 100 === 0) return words.trim();
        words += " ";
        n %= 100;
      }

      words += convertBelowHundred(n);
      return words.trim();
    }

    function convertToWords(n: number): string {
      if (n === 0) return "zéro";
      let result = "";

      if (n >= 1000) {
        const thousands = Math.floor(n / 1000);
        result +=
          thousands === 1
            ? "mille"
            : convertBelowThousand(thousands) + " mille";
        n %= 1000;
        if (n > 0) result += " ";
      }

      result += convertBelowThousand(n);
      return result.trim();
    }

    const [integerPart, decimalPart] = number.toFixed(2).split(".");
    const integerWords = convertToWords(parseInt(integerPart));
    const decimalWords =
      parseInt(decimalPart) > 0 ? `${decimalPart} CTS` : "00 CTS";

    return `(${integerWords} MAD et ${decimalWords})`;
  };
  /**
   * Transfer data to format vue-cal
   */

  // Map weekday names to indices (Sunday = 0, Monday = 1, ...)
  const dayToIndex = {
    Sunday: 0,
    Monday: 1,
    Tuesday: 2,
    Wednesday: 3,
    Thursday: 4,
    Friday: 5,
    Saturday: 6,
  };

  // Get the next occurrence of a specific weekday
  const getNextWeekdayDate = (day) => {
    const today = dayjs();
    const targetDay = dayToIndex[day];
    const daysToAdd = (targetDay - today.day() + 7) % 7; // Calculate difference
    return today.add(daysToAdd, "day").format("YYYY-MM-DD");
  };

  const formatVueCal = () => {
    const planningData = [
      {
        id: 50,
        public_session_id: 17,
        day_of_week: "Monday",
        startTime: "19:00:00",
        endTime: "20:30:00",
        club_id: 1,
      },
      {
        id: 51,
        public_session_id: 17,
        day_of_week: "Wednesday",
        startTime: "19:00:00",
        endTime: "20:30:00",
        club_id: 1,
      },
      {
        id: 52,
        public_session_id: 17,
        day_of_week: "Friday",
        startTime: "19:00:00",
        endTime: "20:30:00",
        club_id: 1,
      },
    ];
    const events = planningData.map((item) => {
      const date = getNextWeekdayDate(item.day_of_week);
      return {
        start: `${date}T${item.startTime}`,
        end: `${date}T${item.endTime}`,
        title: `Session ID: ${item.public_session_id}`,
        content: `Club ID: ${item.club_id}`,
      };
    });
    return events;
  };

  const formatDaysToPeriod = (days: number): string => {
    if (days <= 0) return `(0 ${i18n.t("symbole.day")})`;

    const years = Math.floor(days / 365);
    const remaining_after_years = days % 365;

    const months = Math.floor(remaining_after_years / 30);
    const remaining_after_months = remaining_after_years % 30;

    const weeks = Math.floor(remaining_after_months / 7);
    const remaining_days = remaining_after_months % 7;

    const parts: string[] = [];

    if (years > 0)
      parts.push(`${years} ${i18n.t("symbole.year")}${years > 1 ? "s" : ""}`);
    if (months > 0)
      parts.push(
        `${months} ${i18n.t("symbole.month")}${months > 1 ? "s" : ""}`
      );
    if (weeks > 0)
      parts.push(`${weeks} ${i18n.t("symbole.week")}${weeks > 1 ? "s" : ""}`);
    if (remaining_days > 0)
      parts.push(
        `${remaining_days} ${i18n.t("symbole.day")}${
          remaining_days > 1 ? "s" : ""
        }`
      );

    if (parts.length > 1) {
      return (
        "(" +
        parts.slice(0, -1).join(", ") +
        " et " +
        parts[parts.length - 1] +
        ")"
      );
    }

    return "(" + parts.join(", ") + ")";
  };

  /**
     * Dialog confirmation save pdf or auto print
     * data  : {
        title : '',
        denyButtonText : '',
        cancelButtonText : '',
        confirmButtonText : ''
     * }
     */
  const printOrSaveToPdf = (swalOption: any) => {
    let results = "";
    return Swal.fire({
      title: swalOption?.title ?? "",
      denyButtonText: swalOption?.denyButtonText ?? "",
      cancelButtonText: swalOption?.cancelButtonText ?? "",
      confirmButtonText: swalOption?.confirmButtonText ?? "",
      icon: "warning",
      showDenyButton: true,
      denyButtonColor: "#3085d6",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      showConfirmButton: true,
      confirmButtonColor: "#3085d6",
      allowOutsideClick: false, // ✅ disable closing by clicking outside
      allowEscapeKey: false, // (optional) disable closing with ESC
    }).then(async (result) => {
      if (result.isConfirmed) return "pdf";
      if (result.isDenied) return "print";
      return "cancel"; // or undefined, or null, depending on your use case
    });
  };

  const languages = () => {
    return [
      // "en",
      "fr",
      // "ar"
    ];
  };

  // Function to convert image to Base64 format
  const getBase64Image = (img) => {
    const canvas = document.createElement("canvas");
    canvas.width = img.naturalWidth;
    canvas.height = img.naturalHeight;

    const ctx = canvas.getContext("2d");
    if (ctx) ctx.drawImage(img, 0, 0);

    const dataURL = canvas.toDataURL("image/png"); // Could be 'image/png' as well
    return dataURL;
  };

  return {
    getBase64Image,
    languages,
    printOrSaveToPdf,
    formatDaysToPeriod,
    formatVueCal,
    formaTime,
    playSound,
    priceToWords,
    getColorByIndex,
    formaDate,
    calculateAge,
    DatesSubtract,
    dateAdd,
    DatesAdds,
    redirectTo,
    goBack,
    getListMonths,
  };
}
